import dynamic from 'next/dynamic';
import { ShareByEmailProps } from './ShareByEmail.types';

export const ShareByEmail = dynamic<ShareByEmailProps>(() => import('./ShareByEmail'));
